import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FnfBaseDialog } from '../fnf-base-dialog/fnf-base-dialog';
import { FnfButtons } from '../fnf-buttons/fnf-buttons';

export interface DialogProps {
  subject: string;
  title: string;
  description?: string;
  buttonText: string;
  isLoading: boolean;
  error: string | null | undefined;
  [key: string]: any;
}

@Component({
  selector: 'app-fnf-action-dialog',
  imports: [CommonModule, FnfBaseDialog, FnfButtons],
  templateUrl: './fnf-action-dialog.html',
  styleUrl: './fnf-action-dialog.scss',
})
export class FnfActionDialog {
  visible = input<boolean>(false);

  dialogProps = input<DialogProps>({
    subject: 'this is a default subject',
    title: 'This is a default text',
    description: '',
    buttonText: 'Ok',
    isLoading: false,
    error: null,
  });

  onClose = output<void>();
  onAction = output<void>();

  getFormattedText(type: string): string {
    return this.dialogProps()[type]?.replace(/\\n/g, '<br>') || '';
  }

  close(): void {
    this.onClose.emit();
  }

  action(): void {
    this.onAction.emit();
  }
}
